import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // Ավելացված է
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faTimes } from '@fortawesome/free-solid-svg-icons';
import { API_BASE } from '../apiConfig';

const AdminMessageReply = ({ messageId, onSuccess }) => {
    const { t } = useTranslation(); // Ավելացված է
    const [isOpen, setIsOpen] = useState(false);
    const [replyText, setReplyText] = useState('');
    const [loading, setLoading] = useState(false);

    const handleReply = async (e) => {
        if (e) e.preventDefault();

        if (!messageId) {
            alert(t('error_missing_id'));
            return;
        }

        if (!replyText.trim()) {
            alert(t('error_empty_reply'));
            return;
        }

        setLoading(true);

        try {
            const token = localStorage.getItem('token');

            const res = await fetch(`${API_BASE}/api/messages/reply/${messageId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    reply: replyText
                })
            });

            const data = await res.json();

            if (res.ok) {
                alert(t('reply_sent_success'));
                setReplyText('');
                setIsOpen(false);
                if (onSuccess) onSuccess(); 
            } else if (res.status === 401 || res.status === 403) {
                alert(t('session_expired_error'));
            } else {
                alert(`${t('error')}: ${data.error || t('server_error')}`);
            }
        } catch (error) {
            console.error("Reply error:", error);
            alert(t('connection_error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <button 
                onClick={() => setIsOpen(true)} 
                style={btnStyle}
                onMouseOver={(e) => e.target.style.opacity = '0.8'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
            >
                <FontAwesomeIcon icon={faReply} style={{marginRight: '5px'}} /> {t('btn_reply')}
            </button>

            {isOpen && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <div style={modalHeader}>
                            <h3 style={{margin: 0, fontSize: '16px'}}>{t('reply_modal_title')} #{messageId}</h3>
                            <button onClick={() => setIsOpen(false)} style={closeBtn}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        
                        <form onSubmit={handleReply} style={{ padding: '20px' }}>
                            <textarea
                                style={textareaStyle}
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                                placeholder={t('reply_placeholder')}
                                required
                            />
                            <button 
                                type="submit" 
                                style={{
                                    ...submitBtn,
                                    background: loading ? '#A3AED0' : '#01B574',
                                    cursor: loading ? 'not-allowed' : 'pointer'
                                }} 
                                disabled={loading}
                            >
                                {loading ? t('sending_loader') : t('btn_send_reply')}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

// Ոճերը հանված են առանձին փոփոխականի մեջ ավելի մաքուր կոդի համար
const btnStyle = { padding: '8px 15px', background: '#4318FF', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', transition: '0.3s' };
// ... (մնացած ստիլերը նույնն են)
// Ստիլեր (մի փոքր ավելի մոտեցրել եմ ընդհանուր դիզայնին)
const modalOverlay = { 
    position: 'fixed', 
    top: 0, 
    left: 0, 
    width: '100%', 
    height: '100%', 
    background: 'rgba(15, 23, 42, 0.7)', 
    backdropFilter: 'blur(5px)', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    zIndex: 9999 
};

const modalContent = { 
    background: 'white', 
    borderRadius: '24px', 
    width: '90%', 
    maxWidth: '450px', 
    overflow: 'hidden', 
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' 
};

const modalHeader = { 
    padding: '20px', 
    background: '#1B2559', 
    color: 'white', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center' 
};

const closeBtn = { 
    background: 'none', 
    border: 'none', 
    color: 'white', 
    cursor: 'pointer', 
    fontSize: '18px',
    padding: '5px'
};

const textareaStyle = { 
    width: '100%', 
    height: '150px', 
    padding: '15px', 
    marginBottom: '15px', 
    borderRadius: '16px', 
    border: '1px solid #E0E5F2', 
    background: '#F4F7FE',
    resize: 'none', 
    fontSize: '14px', 
    boxSizing: 'border-box',
    outline: 'none',
    fontFamily: 'inherit'
};

const submitBtn = { 
    width: '100%', 
    padding: '14px', 
    color: 'white', 
    border: 'none', 
    borderRadius: '16px', 
    cursor: 'pointer', 
    fontWeight: 'bold', 
    fontSize: '15px', 
    transition: '0.3s',
    boxShadow: '0 10px 15px -3px rgba(1, 181, 116, 0.2)'
};

export default AdminMessageReply;